// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "505" ? "editor" : chunkId) + "." + {"505": "f9cec2b4f4a32325","882": "2e260ba86940f80f",}[chunkId] + ".js"
}